export const SIDEBAR_OPEN_PX = 268;
export const SIDEBAR_EDGE_PX = 12;

// ── Tab System Redesign — LOCKED constants (issue #48) ──────────────
export const TAB_W = 180;
export const TAB_H = 32;
export const EAR = 14; // slant inset per side
export const TOP_RADIUS = 4; // top corners (inward round)
export const BOTTOM_RAMP = 14; // bottom corners (outward ski-ramp into the seam)
export const OVERLAP = 8; // px each tab laps over its left neighbor
export const STROKE_W = 1;
export const STRIP_LEFT = 64; // gap from menu cluster to the fan
export const MERGE_OFFSET = -1; // px the active tab drops to cover the seam
// Sub-pixel nudge of EVERY tab's bottom ramp so its landing line sits on the
// seam's visual center (not its lower edge). Calibrated by eye at 0.001px
// resolution. Applied uniformly to all trapezoid tabs; combined with the frozen
// vertical position below it keeps every tab's ramp on the seam in every state.
export const TAB_RAMP_DY = -0.568;
export const LINKED_GAP = 7; // top-strip gap === perpendicular tab→+ gap
export const BAR_H = TAB_H + LINKED_GAP; // 39 — the menu bar height
export const NEWTAB_W = 39;
export const NEWTAB_H = 21;
export const NEWTAB_R = 5;
export const FILL_ACTIVE = '#16191b'; // == feature-toolbar bg (the merge depends on equality)
export const FILL_INACTIVE = '#101111';
// Inactive model tabs AND the new-tab button share this fill alpha (25% more
// translucent than the old opaque/0.69 — both now read at the same level).
export const INACTIVE_TAB_OPACITY = 0.75;
export const STROKE_TAB = '#2c2c2c'; // inactive tab outline (25% darker than #3a3a3a)
export const SEAM = '#262626'; // active/merged tab border + toolbar seam (25% darker than #323232)
export const NEUTRAL_700 = '#292929'; // telekinesis-neutral-700 — grey ghost-tab fill
// New-tab hover glow (translucent, no blur) — inlined in Tailwind arbitrary
// classes below since class strings can't interpolate a JS constant.
// Derived — keeps the new-tab rhombus sides parallel to the tab slant and its
// perpendicular gap to the last tab equal to LINKED_GAP.
export const SLANT_LEN = Math.hypot(EAR, TAB_H);
export const NEWTAB_SKEW = (EAR * NEWTAB_H) / TAB_H;
export const NEWTAB_MARGIN_LEFT =
  (LINKED_GAP * SLANT_LEN) / TAB_H - (EAR / TAB_H) * ((TAB_H + NEWTAB_H) / 2);
